var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var AccessType;
(function (AccessType) {
    AccessType[AccessType["SEARCH_RESULT"] = 0] = "SEARCH_RESULT";
    AccessType[AccessType["FULL_RECORD"] = 1] = "FULL_RECORD";
    AccessType[AccessType["IDENTIFIED_RECORD_REQUESTED"] = 2] = "IDENTIFIED_RECORD_REQUESTED";
    AccessType[AccessType["IDENTIFIED_RECORD"] = 3] = "IDENTIFIED_RECORD";
})(AccessType || (AccessType = {}));
export class AccessLedgerSearchInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AccessLedgerSearchInput.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AccessLedgerSearchInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AccessLedgerSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(AccessType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], AccessLedgerSearchInput.prototype, "accessTypes", void 0);
__decorate([
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], AccessLedgerSearchInput.prototype, "timestampStart", void 0);
__decorate([
    IsOptional(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], AccessLedgerSearchInput.prototype, "timestampEnd", void 0);
export class AccessRecordInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AccessRecordInput.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AccessRecordInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AccessRecordInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(AccessType),
    __metadata("design:type", Number)
], AccessRecordInput.prototype, "accessType", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], AccessRecordInput.prototype, "timestamp", void 0);
export class AccessRecord extends AccessRecordInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AccessRecord.prototype, "id", void 0);
export class AccessLedgerSearchResult {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], AccessLedgerSearchResult.prototype, "total", void 0);
__decorate([
    Type(() => AccessRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], AccessLedgerSearchResult.prototype, "results", void 0);
